import { render } from "./ThRules.vue?vue&type=template&id=cb13d052&scoped=true"
const script = {}

import "./ThRules.vue?vue&type=style&index=0&id=cb13d052&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cb13d052"

export default script